import { __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
const Panel = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className } = _a, attributes = __rest(_a, ["as", "className"]);
    const classes = clsx(className, 'panel');
    return React.createElement(Component, Object.assign({}, attributes, { ref: ref, className: classes }));
});
Panel.displayName = 'Panel';
const PanelActions = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className } = _a, attributes = __rest(_a, ["as", "className"]);
    const classes = clsx(className, 'panel-actions');
    return React.createElement(Component, Object.assign({}, attributes, { ref: ref, className: classes }));
});
PanelActions.displayName = 'PanelActions';
const PanelBody = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className } = _a, attributes = __rest(_a, ["as", "className"]);
    const classes = clsx(className, 'panel-body');
    return React.createElement(Component, Object.assign({}, attributes, { ref: ref, className: classes }));
});
PanelBody.displayName = 'PanelBody';
const PanelHeader = React.forwardRef((_a, ref) => {
    var { as: Component = 'div', className } = _a, attributes = __rest(_a, ["as", "className"]);
    const classes = clsx(className, 'panel-heading');
    return React.createElement(Component, Object.assign({}, attributes, { ref: ref, className: classes }));
});
PanelHeader.displayName = 'PanelHeader';
const PanelTitle = React.forwardRef((_a, ref) => {
    var { as: Component = 'h4', className } = _a, attributes = __rest(_a, ["as", "className"]);
    const classes = clsx(className, 'panel-title');
    return React.createElement(Component, Object.assign({}, attributes, { ref: ref, className: classes }));
});
PanelTitle.displayName = 'PanelTitle';
export { Panel, PanelActions, PanelBody, PanelHeader, PanelTitle };
//# sourceMappingURL=index.js.map